export * from './product-information.component';
